import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MasterHomePage } from './master-home.page';

const routes: Routes = [
  {
    path: '',
    component: MasterHomePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MasterHomePageRoutingModule {}
